module.exports = __webpack_public_path__ + "img/vue-dark.5a5f19fb.svg";